import {
    ADMIN_USER_ERROR,
    ADMIN_USER_START,
    ADMIN_USER_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.admin, action = {type: ''}) => {
    switch (action.type) {
        case ADMIN_USER_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case ADMIN_USER_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case ADMIN_USER_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/adminUserReducer.js